import "./RatingInput.scss";

import { Component, h, render } from "preact";

import { StarBigIcon } from "../Icon/icons/fill/StarBigIcon";
import { StarBigOutlineIcon } from "../Icon/icons/outlined/StarBigOutlinedIcon";
import { getCustomText } from "@/utils/getCustomText";
import { useState } from "preact/hooks";

export function RatingInput({ onChange, value = 0, validateError = "" }) {
  const [placeholderValue, setPlaceholderValue] = useState(null);

  return (
    <div className="CCRatingInput t-text">
      <label className="CCRatingInput__label">
        {getCustomText("reviewFormFields.ratingLabel")}
      </label>

      <div
        className="CCRatingInput__stars"
        onMouseLeave={() => setPlaceholderValue(null)}
      >
        {new Array(5).fill(null).map((_, idx) => (
          <Star
            onPlaceholder={(v) => setPlaceholderValue(v)}
            onChange={onChange}
            idx={idx + 1}
            value={placeholderValue !== null ? placeholderValue : value}
          />
        ))}
      </div>

      <div className="CCRatingInput__validateError">{validateError}</div>
    </div>
  );
}

function Star({ idx, value, onPlaceholder, onChange }) {
  return (
    <div
      className="CCStar"
      onMouseEnter={() => onPlaceholder(idx)}
      onClick={() => onChange(idx)}
    >
      {idx <= value ? (
        <StarBigIcon width="45" height="45" />
      ) : (
        <StarBigOutlineIcon width="45" height="45" />
      )}
    </div>
  );
}
